import { useEffect, useState } from 'react';
import { attachmentService } from '../../../services/attachmentService';

// Returns { [storagePath]: signedUrl } for private files. URLs expire after one hour.
export const useSignedUrls = (paths) => {
  const [urls, setUrls] = useState({});
  const key = paths.join('|');

  useEffect(() => {
    if (!paths.length) {
      setUrls({});
      return undefined;
    }
    let alive = true;
    attachmentService
      .signedUrls(paths)
      .then((map) => alive && setUrls(map))
      .catch(() => alive && setUrls({}));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return urls;
};